import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RiskIntelligenceState } from './risk_intelligence_reducer';

export const selectRiskIntelligenceState=createFeatureSelector<RiskIntelligenceState>('RiskIntelligence');

//#region Loading / error

export const selectRiskIntelligenceLoading=createSelector(
  selectRiskIntelligenceState,
  (state: RiskIntelligenceState) => state.loading
);

export const selectRiskIntelligenceError=createSelector(
  selectRiskIntelligenceState,
  (state: RiskIntelligenceState) => state.error
);

//#endregion

//#region Alerts

export const selectAlerts=createSelector(
  selectRiskIntelligenceState,
  (state: RiskIntelligenceState) => state.alerts
);

export const selectActiveAlerts=createSelector(
  selectAlerts,
  (alerts) => alerts.filter(a => a.isActive==true && a.isPublished==true)
);

export const selectAlertsForCountry=(isoCode: string) => createSelector(
  selectAlerts,
  (alerts) => alerts.filter(a =>
    a.relations?.some(r =>
      r.relationType=='country' && (r.code ?? '').toUpperCase()==isoCode.toUpperCase()
    )
  )
);

//#endregion

//#region Advisories

export const selectAdvisories=createSelector(
  selectRiskIntelligenceState,
  (state: RiskIntelligenceState) => state.advisories
);

export const selectAdvisoriesForCountry=(isoCode: string) => createSelector(
  selectAdvisories,
  (advisories) => advisories.filter(a =>
    a.countries?.some(c => (c ?? '').toUpperCase()==isoCode.toUpperCase())
  )
);

export const selectAdvisoryById=(id: string) => createSelector(
  selectAdvisories,
  (advisories) => advisories.find(a => a.id==id)
);

//#endregion

//#region Country Risk Levels / Summaries / PTAs / Country Reports / City Reports / STAs

export const selectCountryRiskLevels=createSelector(
  selectRiskIntelligenceState,
  (state: RiskIntelligenceState) => state.countryRiskLevels
);

export const selectCountryRiskLevelByIso=(isoCode: string) => createSelector(
  selectCountryRiskLevels,
  (riskLevels) => riskLevels.find(r => r.countryIsoCode?.toUpperCase()==isoCode.toUpperCase())
);

export const selectSummaries=createSelector(
  selectRiskIntelligenceState,
  (state: RiskIntelligenceState) => state.summaries
);

export const selectSummaryByIso=(isoCode: string) => createSelector(
  selectSummaries,
  (summaries) => summaries[isoCode?.toUpperCase()]
);

export const selectPtas=createSelector(
  selectRiskIntelligenceState,
  (state: RiskIntelligenceState) => state.ptas
);

export const selectPtaByIso=(isoCode: string) => createSelector(
  selectPtas,
  (ptas) => ptas[isoCode?.toUpperCase()]
);

export const selectCountryReports=createSelector(
  selectRiskIntelligenceState,
  (state: RiskIntelligenceState) => state.countryReports
);

export const selectCountryReportByIso=(isoCode: string) => createSelector(
  selectCountryReports,
  (reports) => reports[isoCode?.toUpperCase()]
);

export const selectCityReports=createSelector(
  selectRiskIntelligenceState,
  (state: RiskIntelligenceState) => state.cityReports
);

export const selectCityReportsList=createSelector(
  selectCityReports,
  (reports) => Object.values(reports)
);

export const selectCityReportByCode=(iataCode: string) => createSelector(
  selectCityReports,
  (reports) => reports[iataCode?.toUpperCase()]
);

export const selectStas=createSelector(
  selectRiskIntelligenceState,
  (state: RiskIntelligenceState) => state.stas
);

export const selectStaByIso=(isoCode: string) => createSelector(
  selectStas,
  (stas) => stas[isoCode?.toUpperCase()]
);

//#endregion

//#region Transient results

export const selectLastTravelSearchResult=createSelector(
  selectRiskIntelligenceState,
  (state: RiskIntelligenceState) => state.lastTravelSearchResult
);

export const selectLastTripReadyResult=createSelector(
  selectRiskIntelligenceState,
  (state: RiskIntelligenceState) => state.lastTripReadyResult
);

export const selectLastLocalRiskLevels=createSelector(
  selectRiskIntelligenceState,
  (state: RiskIntelligenceState) => state.lastLocalRiskLevels
);

//#endregion
